/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import Globals from "../../shared/Globals";
import { qreq } from "../../shared/qrequest";
import BaseCom from "../BaseCom";
import Card from "../Card";
import Icon from "../Icon";
import RequestFormSendModal from "./RequestFormSendModal";
import { Pop } from "../PopModal";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import RequestFormCreateModal from "./RequestFormCreateModal";
import Auth from "../../shared/Auth";

class RequestFormList extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            showSendRequestForm: false
        };
        this.load = this.load.bind(this);
        this.delete = this.delete.bind(this);
    }

    componentDidMount() {
        this.load();
    }

    componentDidUpdate(prevProps) {
        if (this.props.item !== prevProps.item && this.props.item?.id !== prevProps.item?.id)
            this.load();
    }

    load() {
        if (this.props.item && this.props.item.id) {
            qreq.get('/api/form/list?orderID=' + this.props.item.id, j => {
                if (j.list)
                    this.setState({ list: j.list });
            });
        }
    }

    delete(item) {
        Pop.showConfirm(<>Are you sure you want to delete form sent on<br /><strong>{Globals.toMDYHMLocalDateString(item.sentDate)}</strong>?</>, 'Delete Form', () => {
            qreq.post('/api/form/delete', {id: item.id}, j => {
                if(j.errorCode === 0) {
                    this.success('The form has been deleted.');
                    var list = this.state.list.filter(i => i.id !== item.id);
                    this.setState({ list: list });
                }
                else
                    this.alert(j.errorMessage);
            }, this.unkownErrorCallback);
        });
    }

    render() {
        return <>
            <h1>Request Forms</h1>
            <RequestFormSendModal orderID={this.props.item?.id} emails={this.props.item?.referrer?.email} show={this.state.showSendRequestForm} onHide={() => { this.setState({ showSendRequestForm: false }); this.load(); }} />
            <RequestFormCreateModal orderID={this.props.item?.id} show={this.state.showCreateRequestForm} onHide={() => { this.setState({ showCreateRequestForm: false }); this.load(); }} />
            <Card title="Request Forms">
                {!Auth.hasRole('readonly') && <>
                <button type="button" className="btn btn-primary" onClick={() => this.setState({ showSendRequestForm: true })}>Send Form Fill Request</button>
                <button type="button" className="btn btn-secondary" onClick={() => this.setState({ showCreateRequestForm: true })}>Create Form Fill Request to Sign On-Site</button>
                </>}
                <p>You will be asked for recipients on the next screen.</p>
                {this.state.list ? <table className="table table-striped">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Form</th>
                            <th>Sent</th>
                            <th className="d-none d-md-table-cell">Recipients</th>
                            <th className="d-none d-md-table-cell">Completed</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.list.map((item, i) => <tr key={i}>
                            <td><a title="PDF" href={Globals.serverUrl + '/api/form/render/' + item.id + '/' + this.props.item?.patient?.fullName?.replace(/[^a-zA-Z0-9]+/, '-') + '-' + item.requestFormName?.replace(/[^a-zA-Z0-9]+/, '-') + '-' + item.name?.replace(/[^a-zA-Z0-9]+/, '-') + '.pdf'} target="_blank" rel="noreferrer"><Icon icon="faFilePdf" /></a></td>
                            <td><a title="PDF" href={Globals.serverUrl + '/api/form/render/' + item.id + '/' + this.props.item?.patient?.fullName?.replace(/[^a-zA-Z0-9]+/, '-') + '-' + item.requestFormName?.replace(/[^a-zA-Z0-9]+/, '-') + '-' + item.name?.replace(/[^a-zA-Z0-9]+/, '-') + '.pdf'} target="_blank" rel="noreferrer">{Globals.toMDYHMLocalDateString(item.sentDate)}</a></td>
                            <td>{item.requestFormName}</td>
                            <td className="d-none d-md-table-cell">{item.emails}</td>
                            <td className="d-none d-md-table-cell">{item.isFilled ? item.filledDate : 'No'}</td>
                            <td>{!Auth.hasRole('readonly') && !item.isFilled ? <span role="button" className="text-danger" title="Delete" onClick={() => this.delete(item)}><Icon icon="faTrash" /></span> : null}</td>
                        </tr>)}
                    </tbody>
                </table> : <p className="fs-italic">No forms have been sent yet.</p>}
            </Card>
        </>;
    }
}

export default withParamsAndNavigate(RequestFormList);